import { createSlice } from '@reduxjs/toolkit';
import { getAllHousekeys } from './thunks';

// Initial state for Redux store:
export const initialStateHousekeys = {
  housekeys: {
    total: 0,
    housekeys: [],
    keys: [],
    paginate: {
      current_page: 1,
      items: 0,
      pages: 1,
    },
    success: false,
  },
  loading: false,
};

const housekeysSlice = createSlice({
  name: 'housekeys',
  initialState: initialStateHousekeys, // Define initial state
  reducers: {
    setHousekeys: (state: any, action: any) => {
      state.housekeys = action.payload;
    },
    removeKeyById: (state, action) => {
      const keyID = action.payload.id;
      const stateData = JSON.parse(JSON.stringify(state));
      state.housekeys.keys = stateData.housekeys.keys.filter(
        (key: any) => key.id !== keyID
      );
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllHousekeys.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAllHousekeys.fulfilled, (state, action) => {
      state.housekeys = action.payload;
      state.loading = false;
    });
  },
});

// Export actions generated by "createSlice()":
export const { setHousekeys, removeKeyById } = housekeysSlice.actions;

// Export reducer generated by "createSlice()":
export default housekeysSlice.reducer;
